import { Api } from '@/api'
//import { getSeekableBlob } from '@/components/audioRecorder/js/ebml.util'
import COS from 'cos-js-sdk-v5'
import createFn from '@/utils/log'
import { addLogs } from '@/utils/audioRecorderLogs'
export default {
  data() {
    return {
      multipartUploadParams: {
        Bucket: '',
        Region: '',
        Key: '',
        UploadId: ''
      },
      cos: '',
      Parts: []
    }
  },
  created() {},

  methods: {
    cosInit() {
      this.multipartUploadParams = {
        Bucket: '',
        Region: '',
        Key: '',
        UploadId: ''
      }
      this.cos = null
      this.Parts = []
    },

    //查询已上传块
    multipartListPart() {
      this.Parts = []
      addLogs(`录音结束，准备调用模块检查`,this);
      this.cos.multipartListPart(
        {
          ...this.multipartUploadParams
        },
        (err, data) => {
          if (data && data.Part && data.Part instanceof Array) {
            const Part = data.Part
            console.log('已上传模块', Part)
            if (Part.length == 0) { 
              //一片都没成功
              this.$message.error('此为空文件，无法合并，请删除重新录音。')
              addLogs(`此为空文件，无法合并，请删除重新录音。`,this);
              return

            }
            let nums = []

            for (let i = 0; i < Part.length; i++) {
              const num = parseInt(Part[i].PartNumber)
              nums.push(num)

              //创建Parts，用于后续的完成指令
              this.Parts.push({
                PartNumber: Part[i].PartNumber,
                ETag: Part[i].ETag
              })
            }
            const max = Math.max(...nums)
            const noneNum = this.getMissElem(nums, max)
            //查询是否存在丢失的模块
            if (noneNum && noneNum.length > 0) {
              try { 
                const c = noneNum ? JSON.stringify(noneNum) : '[]';
                addLogs(`存在丢失的模块，参数是：${c}`,this);
              }catch(error) {}
              //存在丢失的模块
              this.emptyFileRemediation(noneNum)
            } else {
              //不存在丢失的模块，直接合并
              this.multipartComplete()
            }
            console.log(noneNum)
          }
        }
      )
    },
    //完成分块上传
    multipartComplete() {
      console.log('开始申请分块合并!!!', this.Parts)
      addLogs(`开始申请分块合并。`,this);
      this.cos.multipartComplete(
        {
          ...this.multipartUploadParams,
          Parts: this.Parts
        },
        (err, data) => {
          console.log(err,data)
          this.loading = false
          if (err) {
            this.confirmShow('文件合并失败，请重新尝试。')
            return
          }
          if (data) {
            console.log('文件合并成功', data)
            addLogs(`文件合并成功。`,this);
            Api.updateUploadSchedule({
              uploadId: this.multipartUploadParams.UploadId,
              relationId: this.$store.state.audio.audioMsg.relationId,
              state: 1,
              url: 'https://' + data.Location
            }).then((e) => {
              if (e.code == '0') {
                if (typeof this.uploadCompleted === 'function') {
                  this.uploadCompleted(data)
                }
                this.$store.commit('audio/setAudioListRequest', Math.random())
              }
              else { 
                this.$message.error(e.msg);
              }
            }).finally(()=>{
              addLogs(`文件合并成功，最终更新录音进度。`,this);
              this.uploadLogs();
            })
          }
        }
      )
    },
    //空白文件补救措施
    emptyFileRemediation(noneNum) {
      this.emptyFileRemediationImplement(0, noneNum)
    },
    emptyFileRemediationImplement(i, noneNum) {
      this.cos.multipartUpload(
        {
          ...this.multipartUploadParams,
          PartNumber: noneNum[i],
          Body: this.createTestBlob()
        },
        (err, data) => {
          if (err) {
            this.confirmShow('上传失败，请重新尝试。')
            return
          }
          if (data && data.statusCode == 200) {
            console.log('空白文件补救措施', err)
            if (i === noneNum.length - 1) {
              //最后一个都成功了，就不递归了，弹出一个提示，让用户手动再发起一遍检查
              this.confirmShow('录音所有分块检查完毕，是否生成文件?')
            } else {
              //成功的索引加1，递归执行后面的
              this.emptyFileRemediationImplement(i + 1, noneNum)
            }
          }
        }
      )
    },

    confirmShow(str) {
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'info'
      }).then(() => {
        this.multipartListPart()
      })
    },
    //找出丢失的数字
    getMissElem(arr, max) {
      var result = [],
        obj = {},
        len = arr.length
      for (var i = 0; i < len; i++) {
        obj[arr[i]] = true
      }
      for (var i = 1; i <= max; i++) {
        if (!obj[i]) {
          result.push(i)
        }
      }
      return result
    },
    createTestBlob() {
      const mb = 1.1 // 1MB
      const bytes = mb * 1024 * 1024 // 转换为字节

      // 创建指定字节数的二进制数据
      const binaryData = new ArrayBuffer(bytes)
      const binaryObject = new Blob([binaryData], { type: 'audio/wav' })
      return binaryObject
    },

    //=========================
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    handleFilePlay(item, fileList) {
      const isSafari = this.isSafari();
      
      if(!isSafari && item.multipartUploadRecordDTO && item.multipartUploadRecordDTO.uploadId){
        this.handlePdfLink(item.url, item.name,item,(url, filename)=>{
          const newItem = {
            id:item.id,
            name:filename
          }
          const newFileList = [{
            id:item.id,
            path:url,
            name:filename
          }]
          
          this.playAudio(newItem, newFileList)
        })
      }
      else {
        const newFileList = [{
          id:item.id,
          path:item.url,
          name:item.name
        }]
        this.playAudio(item,newFileList)
      }
    },
    playAudio(item, fileList) {
      if (this.$store.state.audio.audioMsg.isShowAudio || (item.multipartUploadRecordDTO && item.multipartUploadRecordDTO.transCode != 'Success')) { 
        return;
      }
      const audioList = [{
        id: item.id,
        fileUrl:item.url || item.fileUrl,
        fileTitle:item.name || item.fileName,
      }]
      this.$store.dispatch('audio/setPlayStatus', { flag: true, index: null })
      this.$store.commit('audio/setTruelandUiAudioMsg', {
        isShowAudio: true,
        title: item.name,
        type: 1, // /** 控件类型* 0-录音，1-播放 **/
        fileList: audioList
      })
      this.$nextTick(() => {
        const audio = document.querySelector('.video-player video')
        audio.load()
        audio.play()
      })
    },
    // 下载文件
    handleFileDown(item, fileName = '未知文件') {
      if (item.multipartUploadRecordDTO && item.multipartUploadRecordDTO.transCode != 'Success') { 
        return
      }
      const url = item.path || item.url || item.fileUrl;
      const name = item.name || item.fileName
      this.handlePdfLink(url, name);
    },
    // 处理 pdf url，使其不在浏览器打开
    handlePdfLink(url, filename) {
      this.uploading = true;
      fetch(url, {
        method: 'get',
        responseType: 'arraybuffer',
      })
        .then(function(res) {
          if (res.status !== 200) {
            return res.json()
          }
          return res.arrayBuffer()
        })
        .then((blobRes) => {
          // 生成 Blob 对象，设置 type 等信息
          const e = new Blob([blobRes], {
            type: 'application/octet-stream',
            'Content-Disposition': 'attachment'
          })
          const link = window.URL.createObjectURL(e)
          this.handleFileDownload(link, filename)

          // const isSafari = this.isSafari();
          // // 将 Blob 对象转为 url
          // if( !isSafari && item.multipartUploadRecordDTO && item.multipartUploadRecordDTO.uploadId){
          //   //存在这个字段就是1.2.3.3版本新的录音，MediaRecorder API生成的录音没有进度条，这里用getSeekableBlob方法添加一下。
          //   //isSafari 浏览器不能调这个方法，不然直接报错
          //   getSeekableBlob(e,(blob) => {
          //     const link = window.URL.createObjectURL(blob)
          //     if(fn && typeof fn === 'function'){
          //       fn(link, filename)
          //     }
          //   })
          // }
          // else{
          //   //老数据流程
          //   const link = window.URL.createObjectURL(e)
          //   if(fn && typeof fn === 'function'){
          //     fn(link, filename)
          //   }
          // }
        }).catch(err => {
          console.error(err)
          this.uploading = false;
        })
    },
    // 下载文件
    handleFileDownload(url, filename) {
      // 创建 a 标签
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      this.uploading = false;
    },
    createFile(item, relationId) {
      //这里不能在录音时候操作，因为在录音的时候，设置了relationId，当前的录音就完了
      if (this.$store.state.audio.audioMsg.isShowAudio) { 
        return
      }
      this.cosInit();
      this.$store.commit('audio/setRelationId',relationId);
      this.multipartUploadParams.Bucket = item.multipartUploadRecordDTO.bucketName;
      this.multipartUploadParams.Region = item.multipartUploadRecordDTO.regionName;
      this.multipartUploadParams.Key = item.multipartUploadRecordDTO.path;
      this.multipartUploadParams.UploadId = item.multipartUploadRecordDTO.uploadId;
      const filename = encodeURIComponent(item.fileName || item.name + '.mp3');
      Api.generatorTempSecretId({
        filename,
        type: 1,
        path:item.multipartUploadRecordDTO.path
      }).then((res)=>{
        if (res.code == '0' && res.data) {
          this.cos = new COS({
            SecretId: res.data.tmpSecretId,
            SecretKey: res.data.tmpSecretKey,
            XCosSecurityToken: res.data.sessionToken
          })
          this.multipartListPart();
        }
        
      })
    },

    uploadLogs() { 
      try { 
        const logs = localStorage.getItem('zzp-audioRecorder');
        if (logs) {
          const err = {
            message:logs
          }
          const p = createFn(err);
          Api.saveProdLog(p).then((res) => { 
            if (res.code === '0') { 
              //上传成功，则清除掉
              localStorage.removeItem('zzp-audioRecorder');
            }
          })
        }
      } catch (err) { 
        console.log(err)
      }
    }



  }
}
